import { connect } from 'react-redux';
import { fetchPurchaseOrders, selectPurchaseOrder, resetCurrentPurchaseOrder } from '../../actions/purchaseOrders_actions';
import { selectReceive, resetCurrentReceive, fetchReceives } from '../../actions/receive_actions';
import ReceiveList from '../../components/Inventories/receiveList';

function mapStateToProps(state) {
    return {
        currentReceive: state.receives.currentReceive,
        receives: state.receives.all,
        isLoading: state.receives.isLoading,
        error: state.receives.errors,
        userPermissions: state.auth.userPermissions,
        warehouse: state.header.selectedWarehouse
      };
}

export default connect(mapStateToProps, { 
	selectPurchaseOrder, 
	resetCurrentPurchaseOrder, 
	fetchPurchaseOrders, 
	selectReceive, 
	resetCurrentReceive, 
	fetchReceives,
})(ReceiveList);



// WEBPACK FOOTER //
// ./master/jsx/containers/Inventories/receiveList.jsx